export const BLUE_LIVE = false;

export const PREVIEW_PATH = "/preview/home";
export const BLUE_PREVIEW_PATH = PREVIEW_PATH;

export const BLUE_ROUTES = BLUE_LIVE ? ["/", "/about", "/solutions", "/industries", "/careers", "/contact"] : [];

const matches = (r, pathname) => (r === "/" ? pathname === "/" : pathname === r || pathname.startsWith(`${r}/`));

export const themeFor = (pathname) => {
  if (matches(PREVIEW_PATH, pathname)) return "pan";
  if (BLUE_ROUTES.some((r) => matches(r, pathname))) return "blue";
  return null;
};

export const isBlueRoute = (pathname) => themeFor(pathname) === "blue";
